<div class="photo-viewer" *ngIf="currentImage as image">
  <button mat-icon-button class="photo-viewer__close" (click)="close()" aria-label="Close viewer">
    <mat-icon>close</mat-icon>
  </button>

  <button mat-icon-button class="photo-viewer__nav photo-viewer__nav--left" (click)="prev()" aria-label="Previous image">
    <mat-icon>chevron_left</mat-icon>
  </button>

  <figure class="photo-viewer__figure">
    <img [src]="image.url" [alt]="image.title" class="photo-viewer__image" />
    <figcaption class="photo-viewer__caption">
      <span>{{ image.title }}</span>
      <span>{{ currentIndex + 1 }} / {{ data.images.length }}</span>
    </figcaption>
  </figure>

  <button mat-icon-button class="photo-viewer__nav photo-viewer__nav--right" (click)="next()" aria-label="Next image">
    <mat-icon>chevron_right</mat-icon>
  </button>
</div>
